import React from 'react';
import { Quote } from 'lucide-react';
export function TestimonialSection() {
  const testimonials = [{
    name: 'Lic. Mariana Ruiz',
    role: 'Psicopedagoga',
    city: 'Buenos Aires',
    initials: 'MR',
    color: 'bg-pink-100 text-pink-700',
    text: 'Antes pasaba los domingos planificando. Con este sistema recuperé mi fin de semana y voy a las sesiones mucho más segura. Las familias notan la organización.'
  }, {
    name: 'Lic. Carolina Méndez',
    role: 'Especialista en Aprendizaje',
    city: 'Ciudad de México',
    initials: 'CM',
    color: 'bg-purple-100 text-purple-700',
    text: 'Es justo lo que necesitaba. No es teoría vacía, son herramientas reales. Las fichas son excelentes y a los chicos les encantan porque no se sienten infantilizados.'
  }, {
    name: 'Lic. Valentina Torres',
    role: 'Psicopedagoga Clínica',
    city: 'Bogotá',
    initials: 'VT',
    color: 'bg-blue-100 text-blue-700',
    text: 'La estructura de 6 meses me dio un norte claro. Ya no dudo si estoy avanzando bien. El registro clínico por sesión es un salvavidas para los informes.'
  }, {
    name: 'Lic. Fernanda Lagos',
    role: 'Psicopedagoga',
    city: 'Santiago',
    initials: 'FL',
    color: 'bg-teal-100 text-teal-700',
    text: 'Increíble el ahorro de tiempo. Lo compré dudando y hoy es mi base de trabajo. Los bonos de comunicación con la familia me ayudaron a poner límites claros.'
  }, {
    name: 'Lic. Sofía Alarcón',
    role: 'Terapeuta de Aprendizaje',
    city: 'Lima',
    initials: 'SA',
    color: 'bg-amber-100 text-amber-700',
    text: 'Lo mejor es que no es rígido. Me da la estructura pero puedo adaptar. Mis pacientes han avanzado más rápido desde que ordené mi intervención con este sistema.'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-177">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="text-center mb-16" data-id="element-179">
          <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-180">
            Lo que dicen colegas que ya usan el sistema
          </h2>
          <p className="text-lg text-slate-600" data-id="element-181">
            Profesionales reales recuperando su tiempo y seguridad clínica
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-182">
          {testimonials.map((testimonial, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-183">
              <div className="flex items-center gap-4 mb-4" data-id="element-184">
                <div className={`w-12 h-12 rounded-full ${testimonial.color} flex items-center justify-center font-bold text-lg`} data-id="element-185">
                  {testimonial.initials}
                </div>
                <div data-id="element-186">
                  <p className="font-bold text-slate-900" data-id="element-187">{testimonial.name}</p>
                  <p className="text-xs text-slate-500" data-id="element-188">
                    {testimonial.role} • {testimonial.city}
                  </p>
                </div>
              </div>
              <div className="relative" data-id="element-189">
                <Quote className="w-8 h-8 text-slate-100 absolute -top-2 -left-2 -z-10" data-id="element-190" />
                <p className="text-slate-600 italic text-sm leading-relaxed" data-id="element-191">
                  "{testimonial.text}"
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}